import { useLocation } from 'react-router-dom'

import { canAccess } from '@/access/roleAccess'
import { selectRoleKey } from '@/features/auth/slices/sessionSlice'
import RoleBlockedPage from '@/pages/RoleBlockedPage'
import { useAppSelector } from '@/store'

/**
 * The ROLE gate, enforced beside the policy it reads (guard order position 3,
 * after `AuthGuard` — I-5). It renders the refusal IN PLACE and never rewrites
 * the URL, so a shared deep link stays inspectable. `canAccess` stays the
 * single enforcement point; the session's derived `roleKey` is the only input
 * that changed in W6.1.
 *
 * `roleKey === null` renders the refusal too (defensive only: AuthGuard's
 * ordering means an unauthenticated visitor never reaches this gate).
 */
export function RoleGuarded({ children }: { children: React.ReactNode }) {
  const roleKey = useAppSelector(selectRoleKey)
  const { pathname } = useLocation()
  if (roleKey === null || !canAccess(roleKey, pathname)) {
    return <RoleBlockedPage requested={pathname} />
  }
  return <>{children}</>
}
